import { CacheKey } from '../enum/cache-key.enum';
import { Session } from '../model/session.model';

const getSession = (): Session => {
  const session = JSON.parse(
    localStorage.getItem(CacheKey.USER_SESSION) || '{}',
  ) as Session;
  return session;
};

export const SecurityManager = {
  loggedIn: (): boolean => {
    let session = getSession();

    if (session && session.authToken && session.authToken.length > 0) {
      return true;
    } else {
      return false;
    }
  },

  setSession(session: Session) {
    localStorage.setItem(CacheKey.USER_SESSION, JSON.stringify(session));
  },

  updateAuthToken(authToken: string) {
    const session = getSession();
    session.authToken = authToken;
    localStorage.setItem(CacheKey.USER_SESSION, JSON.stringify(session));
  },

  getAuthToken: (): string => {
    let session = getSession();
    return session.authToken;
  },

  getAccessToken: (): string => {
    let session = getSession();
    return session.accessToken;
  },

  getUid: (): string => {
    let session = getSession();

    return session.userId;
  },

  getTestId: (): string => {
    let session = getSession();

    return session.testId;
  },

  getPreview: (): boolean => {
    let session = getSession();
    return session.preview ?? false;
  },

  logout() {
    try {
      localStorage.removeItem(CacheKey.USER_SESSION);
    } catch (err) {
      console.error(err);
    }
  },
};
